import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { initializeArrayWithRange } from "../../utils";

const TripIntervalSelect = ({
  name,
  label,
  value,
  onChange,
  range = [15, 30],
  step = 15
}) => {
  const options = initializeArrayWithRange(range[1], range[0], step);

  return (
    <Field>
      <Label>{label}</Label>
      <Control iconLeft>
        <Select.Container fullwidth>
          <Select name={name} value={value} onChange={onChange}>
            {options.map(opt => (
              <Select.Option value={opt}>{`${opt} minutes`}</Select.Option>
            ))}
          </Select>
        </Select.Container>
        <Icon align="left">
          <FontAwesomeIcon icon="clock" />
        </Icon>
      </Control>
    </Field>
  );
};

TripIntervalSelect.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  range: PropTypes.array,
  step: PropTypes.number
};
export default TripIntervalSelect;
